import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { jsx } from 'react/jsx-runtime';

const serviceGroupInfoCard = EntityCardBlueprint.make({
  name: 'service-group',
  params: {
    type: 'info',
    // Only entities that actually have a ServiceGroup relation - currently
    // just Components, but this stays correct if ServiceGroup ever gets
    // attached to another kind. The EntityPredicate object DSL can't express
    // "relation of this type targeting this kind" (targetRef is an opaque
    // string, no substring operator), so this uses the plain function form.
    filter: entity =>
      Boolean(
        entity.relations?.some(
          r => r.type === 'partOf' && r.targetRef.startsWith('servicegroup:'),
        ),
      ),
    loader: () =>
      import('./ServiceGroupInfoCard').then(m =>
        jsx(m.ServiceGroupInfoCard, {}),
      ),
  },
});

export const serviceGroupCardModule = createFrontendModule({
  pluginId: 'app',
  extensions: [serviceGroupInfoCard],
});
